/*
 * Copyright (C) 2025 JPMorgan Chase & Company
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, is not permitted.
 */

import React from 'react';
import {createRoot} from 'react-dom/client';
import './App.scss';
import App from './App';
import {BrowserRouter} from 'react-router-dom';
import {ExdsTheme} from '@exds/theme';


const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <ExdsTheme>
    <BrowserRouter><App/></BrowserRouter>
  </ExdsTheme>
);
